

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OtpEnterManage = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      navigate('/manageemail');
    }
  }, [email, navigate]);

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleNextClick = async () => {
    if (!otp || otp.length !== 4) {
      setError('Please enter a valid 4-digit OTP');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://server-side-influencer.onrender.com/manager/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otpCode: otp }),
      });

      const data = await response.json();

      if (response.status === 200) {
        toast.success('OTP verified successfully');
        navigate('/changepassmanage');
      } else {
        toast.error(data.message || 'Failed to verify OTP');
      }
    } catch (err) {
      toast.error('Error: OTP verification failed');
      navigate('/manageemail');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center min-h-screen p-6 bg-white ">
      
      {/* Title at the very top of the screenssdddd */}
      <h3 className="mt-10 absolute top-0 left-1/2 transform -translate-x-1/2 text-3xl lg:text-3xl xl:text-3xl font-semibold mb-6 text-black">
        Please enter the received OTP
      </h3>


      <div className="flex flex-col justify-center items-center w-full max-w-md mt-3">
        
        {/* Email input field */}
        <form className="max-w-sm w-full mb-4">
          <label htmlFor="email-input" className="block mb-2 text-sm font-medium text-gray-900">
            Email:
          </label>
          <div className="relative">
            <input
              type="text"
              id="email-input"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 mb-4"
              value={email}
              readOnly
            />
          </div>
        </form>

        {/* OTP input field */}
        <form className="max-w-sm w-full">
          <label htmlFor="otp-input" className="block mb-2 text-sm font-medium text-gray-900">
            OTP:
          </label>
          <div className="relative">
            <input
              type="text"
              id="otp-input"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-3 mb-4"
              placeholder="Enter OTP"
              required
              value={otp}
              onChange={handleOtpChange}
              maxLength={4}
            />
          </div>
          <p className="mt-2 text-sm text-gray-500">Enter the 4-digit OTP sent to your email.</p>
        </form>

        {/* Error message */}
        {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

        {/* Next Button */}
        <button
          onClick={handleNextClick}
          className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 transition duration-300"
          disabled={loading}
        >
          {loading ? 'Verifying OTP...' : 'Next'}
        </button>
      </div>

      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default OtpEnterManage;
